<template>
  <div
    ref="scrollDOM"
    class="py-2 px-4 text-base-content/50 overflow-auto"
    @scroll="onScroll"
  >
    <!-- 节点1 -->
    <template v-for="(item, idx) in store.endingList">
      <div v-if="store.nodeMap[item]" :key="item">
        <h2 class="text-base font-bold mt-2 mb-2.5">
          {{ t("game.tab.endings") }} {{ idx + 1 }}
        </h2>
        <NodeGalGameEditor :node="store.nodeMap[item]" />
      </div>
    </template>
    <!-- 添加内容节点 -->
    <div class="text-center mt-4">
      <button class="btn btn-xs rounded" @click="store.addNode({ type: 3 })">
        <i class="iconfont icon-a- text-xs font-light"></i>
        {{ t("Buttons.addEnding") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { ref } from "vue";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const store = useGalGameEditor();
const { t } = useI18n();
const scrollDOM = ref<HTMLDivElement | null>(null);

const onScroll = (e: Event) => {
  const target = e.target as HTMLDivElement;
  store.scrollTopCache = target.scrollTop;
};

onMounted(async () => {
  if (store.scrollTopCache) {
    scrollDOM.value!.scrollTop = store.scrollTopCache;
  }
});
</script>

<style scoped>
/* Your CSS code goes here */
</style>
